export default __webpack_public_path__ + "static/media/IndoKart.d9c4a935.svg";